<template>
  <li :class="{ 'timeline-inverted': inverted }">
    <slot name="badge">
      <div class="timeline-badge" :class="badgeType">
        <i :class="badgeIcon"></i>
      </div>
    </slot>
    <div id="timeline-item" class="timeline-panel" :class="itemType">
      <div class="timeline-heading"><slot name="header"></slot></div>
      <div class="timeline-body" v-if="$slots.content">
        <slot name="content"></slot>
      </div>
      <div v-if="$slots.footer" class="timeline-footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </li>
</template>
<script>
export default {
  name: 'time-line-item',
  props: {
    inverted: Boolean,
    badgeType: {
      type: String,
      default: 'success'
    },
    badgeIcon: {
      type: String,
      default: ''
    },
   itemType: {
      type: String,
      default: ''
    }
  }
};
</script>
<style>
.button-anexo{
   margin-left: 5px;
}

/* 
#timeline-item {
  background-color: red;
}
*/

/* #timeline-item:before {    
  position: absolute;
    top: 26px;
    right: -15px;
    display: inline-block;
    border-top: 15px solid transparent;
    border-left: 15px solid #222a42;
    border-right: 0 solid #222a42;
    border-bottom: 15px solid transparent;
    content: " ";
} */
/* 
#timeline-item:after {
  display: none;
      position: absolute;
    top: 27px;
    right: -14px;
    display: inline-block;
    border-top: 14px solid transparent;
    border-left: 14px solid green;
    border-right: 0 solid blue;
    border-bottom: 14px solid transparent;
    content: " ";
} */
</style>
